import type { Catalog } from "../../en";

/** Filipino: platform admin support screen (mirrors en). */
export const support: Catalog["adminScreens"]["support"] = {
  title: "Suporta",
  subtitle: "Mga ticket mula sa mga tenant workspace at mga ulat ng maling paggamit mula sa end users. SLA: Urgent 1h · High 4h · Normal 1 araw ng trabaho.",
  impersonationLog: "Log ng impersonation",
  newTicket: "Bagong ticket",
  stats: {
    open: "Bukas na ticket",
    urgent_one: "{{count}} urgent",
    urgent_other: "{{count}} urgent",
    noUrgent: "Walang urgent",
    firstResponse: "Unang tugon (7d)",
    csat: "CSAT (30d)",
    notTracked: "Hindi pa sinusukat",
    abuse: "Mga ulat ng abuso",
    awaiting: "naghihintay ng review",
  },
  tabs: { label: "Mga seksyon ng suporta", tickets: "Mga ticket", abuse: "Mga ulat ng abuso" },
  list: {
    search: "Hanapin ang subject, tenant, ticket #",
    views: { label: "Mga view ng ticket", open: "Bukas", mine: "Naka-assign sa akin", urgent: "Urgent", closed: "Sarado" },
    emptyTitle: "Walang ticket sa view na ito",
    emptyBody: "Dito lumalabas ang mga ticket na ipinapadala ng mga tenant mula sa kanilang workspace. Puwede ka ring mag-log ng isa.",
    emptySearch: "Walang ticket na tugma sa “{{q}}”. Subukan ang pangalan ng tenant o ibang salita mula sa subject.",
    clearSearch: "I-clear ang paghahanap",
    unassigned: "Walang naka-assign",
    label: "Mga ticket",
  },
  priority: { urgent: "Urgent", high: "Mataas", normal: "Normal" },
  status: { open: "Bukas", pending: "Hinihintay ang tenant", eng: "Nasa engineering", closed: "Sarado" },
  sla: {
    left: "{{time}} na lang",
    overdue: "Lampas na ng {{time}}",
    closed: "Sarado",
    none: "Walang SLA",
    hours: "{{h}}h {{m}}m",
    minutes: "{{m}}m",
  },
  detail: {
    back: "Lahat ng ticket",
    selectTitle: "Pumili ng ticket",
    selectBody: "Pumili ng ticket sa listahan para basahin ang thread, sumagot o mag-escalate.",
    notFoundTitle: "Hindi nahanap ang ticket",
    notFoundBody: "Maaaring natanggal na ito, o mali ang link.",
    meta: "{{tenant}} · naka-assign kay {{assignee}}",
    more: "Iba pang aksyon sa ticket",
    assignTo: "I-assign kay {{name}}",
    assignMe: "I-assign sa akin",
    unassign: "Alisin ang assignee",
    assigned: "Naka-assign na kay {{name}}",
    unassigned: "Wala nang assignee ang ticket",
    raisePriority: "Itaas ang priority",
    priorityRaised: "Itinaas ang priority sa {{priority}}",
    copyLink: "Kopyahin ang link ng ticket",
    linkCopied: "Nakopya ang link ng ticket",
    copyFailed: "Hindi makopya ang link",
    impersonate: "I-impersonate ang tenant",
    escalate: "I-escalate sa engineering",
    close: "Isara ang ticket",
    reopen: "Buksan muli",
    closed: "Naisara ang {{ref}}",
    reopened: "Nabuksan muli ang {{ref}}",
    impersonateReason: "{{ref}} · {{subject}}",
  },
  thread: {
    label: "Usapan",
    internalNote: "Internal note",
    staffTeam: "CRUD.IT Support",
    staffFallback: "CRUD.IT staff",
    tenantFallback: "User ng tenant",
    empty: "Wala pang mensahe. Ipadala ang unang sagot sa ibaba.",
  },
  composer: {
    modes: { label: "Uri ng mensahe", reply: "Sumagot sa tenant", note: "Internal note" },
    replyLabel: "Sagot",
    replyPlaceholder: "Sumulat ng sagot… makakatanggap ang tenant ng email at in-app notification.",
    noteLabel: "Internal note",
    notePlaceholder: "Mga CRUD.IT staff lang ang makakakita ng internal notes.",
    send: "Ipadala ang sagot",
    addNote: "Idagdag ang internal note",
    sent: "Naipadala ang sagot · na-email ang tenant",
    noteAdded: "Naidagdag ang internal note",
    emptyReply: "Sumulat muna ng sagot",
    emptyNote: "Sumulat muna ng note",
  },
  context: {
    label: "Konteksto ng tenant",
    plan: "Plan",
    mrr: "MRR",
    messages: "Mga mensahe",
    messagesValue: "{{used}} / {{limit}}",
    since: "Customer mula",
    status: "Status",
    open: "Buksan ang tenant",
  },
  escalate: {
    title: "I-escalate sa engineering",
    description: "Lilipat ang ticket sa “Nasa engineering” at mala-log ang escalation sa audit trail.",
    component: "Component",
    components: {
      rag: "RAG / retrieval",
      ingestion: "Ingestion at OCR",
      llm_gateway: "LLM gateway",
      widget: "Widget / SSE",
      channels: "Mga channel (Messenger)",
      billing: "Billing",
    },
    severity: "Severity",
    severities: { sev3: "SEV-3", sev2: "SEV-2", sev1: "SEV-1" },
    assignee: "I-assign kay",
    notes: "Mga tala para sa engineering",
    notesPlaceholder: "Ano ang nakita mo, ano ang sinubukan mo, at aling sagot o trace ang nagpapakita nito.",
    traces: "Isama ang huling 5 trace ng tenant na ito",
    submit: "I-escalate",
    done: "Na-escalate sa engineering · {{ref}}",
  },
  create: {
    title: "Bagong ticket",
    description: "Mag-log ng ticket para sa isang tenant workspace. Magsisimula na ang SLA.",
    tenantSearch: "Tenant",
    tenantSearchPlaceholder: "Hanapin ang tenant ayon sa pangalan…",
    tenant: "Tugmang tenant",
    noTenants: "Walang tugmang tenant",
    subject: "Subject",
    subjectPlaceholder: "hal. Follow-up sa onboarding call",
    subjectRequired: "Maglagay ng subject.",
    tenantRequired: "Pumili ng tenant.",
    priority: "Priority",
    assignee: "Assignee",
    submit: "Gumawa ng ticket",
    done: "Nagawa ang ticket {{ref}}",
  },
  abuse: {
    title: "Mga ulat ng abuso",
    description: "Iniulat gamit ang “Report this answer” link sa widget, ng mga tenant, o na-flag ng moderation. Naka-log ang mga desisyon sa Audit Logs.",
    columns: { report: "Ulat", tenant: "Tenant · agent", reason: "Dahilan", source: "Pinagmulan", evidence: "Ebidensya", status: "Status", action: "Aksyon" },
    filter: "Filter ng status",
    filters: { all: "Lahat", open: "Kailangang i-review", reviewing: "Nire-review", actioned: "Inaksyunan", dismissed: "Ibinasura" },
    statuses: { open: "Kailangang i-review", reviewing: "Nire-review", actioned: "Inaksyunan", dismissed: "Ibinasura" },
    reasons: {
      prompt_injection: "Prompt-injection campaign",
      misleading: "Mapanlinlang na pahayag",
      credentials: "Nangongolekta ng credentials",
      spam: "Spam / flooding",
    },
    sources: {
      guardrail: "Auto-flag ng guardrail",
      end_user: "Ulat ng end user",
      moderation: "Moderation",
      rate_limiter: "Rate limiter",
    },
    reportCount_one: "{{count}} ulat",
    reportCount_other: "{{count}} ulat",
    agentLinked: "May naka-link na agent",
    noAgent: "Walang agent",
    view: "Tingnan",
    viewLabel: "Tingnan ang ebidensya para sa {{ref}}",
    actions: {
      block_ip: "I-block ang IP",
      dismiss: "Ibasura",
      warn: "Babalaan ang tenant",
      suspend_agent: "I-suspend ang agent",
      block_agent_key: "Bawiin ang agent key",
      suspend_tenant: "I-suspend ang tenant",
    },
    actioned: "{{action}} · {{when}}",
    done: {
      block_ip: "Na-block ang IP para sa tenant na ito",
      dismiss: "Ibinasura ang ulat",
      warn: "Na-email ang babala sa may-ari ng tenant",
      suspend_agent: "Na-suspend ang agent · naka-log bilang agent.suspended",
      block_agent_key: "Nabawi ang agent key",
      suspend_tenant: "Na-suspend ang tenant",
    },
    emptyTitle: "Walang ulat ng abuso",
    emptyBody: "Dito lumalabas para i-review ang mga ulat mula sa “Report this answer” link ng widget, mga flag ng guardrail at moderation.",
    emptyFiltered: "Walang ulat na may ganitong status. Ipakita na lang ang lahat ng ulat.",
    showAll: "Ipakita ang lahat ng ulat",
    openAudit: "Buksan ang audit log",
    evidence: {
      title: "Ebidensya · {{ref}}",
      description: "Ang naitala ng ulat. Hindi pa available sa API ang excerpt ng usapan.",
      summary: "Buod",
      reason: "Dahilan",
      source: "Pinagmulan",
      tenant: "Tenant",
      reported: "Iniulat",
      count: "Mga ulat",
      decision: "Desisyon",
      undecided: "Wala pang desisyon",
    },
    suspend: {
      title: "I-suspend ang agent na ito?",
      description: "Ipapakita ng widget, web app at Messenger channel ang “This assistant is temporarily unavailable.” Makakapag-log in at makakapag-export pa rin ang tenant.",
      message: "Mensahe sa may-ari ng tenant",
      messageDefault: "Na-suspend ang inyong agent dahil sa paglabag sa Sagot Acceptable Use Policy. Sumagot sa email na ito para mag-apela.",
      submit: "I-suspend ang agent",
    },
  },
};
